import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d1cb2f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, null, -1))
const _hoisted_3 = { class: "card-body d-flex row" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "product-img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-title text-muted" }
const _hoisted_9 = { class: "card-text text-primary" }
const _hoisted_10 = { class: "card-text text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (_ctx.$router.push('/superadmin/daftar-product/detail/' + item._id)),
            class: "card product-card col-4",
            style: {"width":"18rem"},
            key: `product-${index}`
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: item.mainImage,
                class: "card-img-top product-img-content",
                alt: "..."
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h6", _hoisted_8, _toDisplayString(item.title), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.formatPrice(item.price)), 1),
              _createElementVNode("p", _hoisted_10, "Stock : " + _toDisplayString(item.stock), 1)
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ], 2)
  ], 64))
}